import PropTypes from "prop-types";

/**
 * Renders up/down caret icons for a sortable column header.
 * The active sort direction fills one caret; the inactive one is outlined.
 *
 * @param {boolean} props.active    - whether this column is the current sort key
 * @param {string}  props.direction - "ascending" | "descending"
 */
const SortIcons = ({ active, direction }) => {
    if (active && direction === "ascending") {
        return (
            <span className="icon-container">
                <i className="bi bi-caret-up-fill" />
                <i className="bi bi-caret-down" style={{ marginBottom: "5px" }} />
            </span>
        );
    }
    if (active && direction === "descending") {
        return (
            <span className="icon-container">
                <i className="bi bi-caret-up" />
                <i className="bi bi-caret-down-fill" style={{ marginBottom: "5px" }} />
            </span>
        );
    }
    return (
        <span className="icon-container">
            <i className="bi bi-caret-up" />
            <i className="bi bi-caret-down" style={{ marginBottom: "5px" }} />
        </span>
    );
};

SortIcons.propTypes = {
    active: PropTypes.bool,
    direction: PropTypes.oneOf(["ascending", "descending"])
};

SortIcons.defaultProps = {
    active: false,
    direction: "ascending"
};

export default SortIcons;
